/**
 * NeedsDetailsChip - marks an account made from an opportunity's customer
 * name alone (crm_accounts.needs_details, 10/11/26: every opportunity is
 * linked to an account, even one nobody has filled in yet). Saving the
 * account form, or filling in one of its details, takes the flag off.
 */
export default function NeedsDetailsChip() {
  return (
    <span
      title="Made from an opportunity's customer name - open Edit to add its details"
      style={{
        fontSize: 9.5,
        fontWeight: 700,
        color: '#8D6E00',
        background: '#FFF8E1',
        border: '1px solid #FFE082',
        borderRadius: 10,
        padding: '1px 7px',
        whiteSpace: 'nowrap',
      }}
    >
      Needs details
    </span>
  );
}
